/*============ SignIn-Out Controller
 ================================*/
angular
    .module('vppApp') 
    .controller('accountVerificationController', accountVerificationController);

accountVerificationController.$inject = ['$window', '$scope', '$rootScope', '$location', 'vppConfig', 'apiFactory', '$state', '$http', 'AuthenticationService', 'DTMTrackerService', '$stateParams', '$cookies', 'CreateAccountService'];

function accountVerificationController($window, $scope, $rootScope, $location, vppConfig, apiFactory, $state, $http, AuthenticationService, DTMTrackerService, $stateParams, $cookies, CreateAccountService) {
    var service = {};

    $scope.user = {
        email: ''
    }

    $cookies.remove('createAccountDirect');

    if($cookies.get("Verification")){
        apiFactory.getVerificationEmail().then(function success(response) {
            $scope.user.email = response.data;
            $cookies.remove('Verification');
        },
        error =>{
            $state.go('sign-in-notice');
        });
    }else{
        $state.go('sign-in-notice');
    }

    $scope.siteCode = vppConfig.folderPath;
    $scope.responsePending = false;

    $scope.resendVerification = function() {
        $scope.responsePending = true;

        apiFactory.postResendVerificationEmail($scope.user.email, $scope.siteCode).then(function(response){
            $scope.responsePending = false;
            $scope.toggleModal('emailSentConfirmation');
         }, function errorCallBack(response) {
                $scope.responsePending = false;
                $scope.serverError = response.data.errors;      
        });    
    }
}
